const ChurchOfferings = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 text-center">
      <h2 className="text-3xl font-bold text-blue-800 mb-6">
        Church Offerings
      </h2>
      <p>Your generous giving supports our ministry. Thank you!</p>
    </div>
  );
};

export default ChurchOfferings;